import axios from 'axios';
import { resetUserPermission } from '../Redux/UserPermissionSlice';
import { resetUserInformation, setUserInformation } from '../Redux/UserInformationSlice';
import { store } from '../Redux/Store';
import publicApi from './appPublicApi';
import jwt_decode from 'jwt-decode';

const apiClient = axios.create({
  withCredentials: true,
});

let refreshPromise = null;

const buildLoginRedirectPath = () => {
  const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return `/login?redirect=${encodeURIComponent(currentPath)}`;
};

export const handleAuthenticatedApiError = async (error) => {
  const { config, response } = error;
  const isTokenUnauthorized =
    response?.status === 401 && response?.data?.reason === 'token_unauthorized';

  if (!config || !isTokenUnauthorized || config._retry) {
    return Promise.reject(error);
  }

  config._retry = true;

  if (!refreshPromise) {
    refreshPromise = publicApi
      .post('/api/app/auth/refresh')
      .then((response) => {
        const token = response.data?.token;
        const decoded = jwt_decode(token);
        const currentUserInformation = store.getState().userInformation.value;
        store.dispatch(
          setUserInformation({
            ...currentUserInformation,
            userID: decoded.user_id,
            token,
          }),
        );
        return response;
      })
      .catch((refreshError) => {
        store.dispatch(resetUserPermission());
        store.dispatch(resetUserInformation());

        if (window.location.pathname !== '/login') {
          window.location.replace(buildLoginRedirectPath());
        }

        throw refreshError;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  try {
    await refreshPromise;
    return apiClient(config);
  } catch (refreshError) {
    return Promise.reject(refreshError);
  }
};

apiClient.interceptors.response.use((response) => response, handleAuthenticatedApiError);

export default apiClient;
